// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__8Nkr+","textbox":"textbox__ZgsP7","suffix":"suffix__OA+Mn"};